import { findAllByTestId } from "@testing-library/react"
import { format } from "date-fns"
import React, { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, useLocation, useNavigate } from "react-router-dom"

import ClaimForm from "./ClaimForm"
import leftArrow from "../../../assets/common/prvsArrow.svg"
import CustomDropdown from "../../../components/Common/Form/Dropdown"
import { ErrorField } from "../../../components/Common/Form/Error"
import { InputBox } from "../../../components/Common/Form/InputBox/InputBox"
import Loader from "../../../components/Common/Loader/loader"
import ToastNotification, { notify } from "../../../components/Toast"
import { userRoles } from "../../../components/Utility/userRoles"
import { SendClaimForm } from "../../../services/mutations"
import {
    GetClaimCreateFormData,
    GetPartPrice,
    useGetTypeNumbersList as GetPrerequisiteData
} from "../../../services/queries"
import { isValidEmailRegx } from "../../../utils/Constant"
import { customNotification, getActivityIdByPathname, isObjectEmpty } from "../../../utils/utils"
import { ClaimFormData } from "./FormData"
import { v4 as uuidv4 } from "uuid"
const dataObject ={}
const REQUIRED_VALUE = "Please Enter the Value"
const OrderClaim = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const searchParams = new URLSearchParams(location?.search)
    const orderId = searchParams && searchParams.get("orderId")
    const  state  = location?.state
    const loginDetails = sessionStorage.getItem("userDetails")
    const loggedInUserDetails = loginDetails
        ? JSON.parse(loginDetails)?.user_details
        : {}
    const { formDetails, validationRules,partRecord,validatePartRules } = ClaimFormData()
    const [loader, setLoader] = useState(true)
    const [errors, setErrors] = useState({})
    const [partErrors, setPartErrors] = useState({})
    const [claimFormDetails, setClaimFormDetails] = useState({ ...formDetails })
    const [claimParts,setClaimParts] = useState([])
    const [selectedPartNo,setSelectedPartNo] = useState()
    const [totalDebit,setTotalDebit] = useState(0)
    const [totalCredit,setTotalCredit] = useState(0)
    const [key, setKey] = useState(0)
    const { data: prerequisiteData ={} } = GetPrerequisiteData()
    const { mutateAsync: sendClaimForm } = SendClaimForm()
    const activityId = getActivityIdByPathname(location?.pathname)
    const permission = userRoles().findUserRolesForPage(
        activityId[0]?.activity_id
    )

    useEffect(() => {
        if(Object.keys(prerequisiteData).length) {
            dataObject.associate = prerequisiteData
        }
    }, [prerequisiteData,claimFormDetails])
    
    const {
        isLoading : pageDataLoading,
        failureReason :pageDataFailure,
        data: orderClaimData
    } = GetClaimCreateFormData(
        orderId
    )
    
    const {
        isLoading : partPriceLoading,
        failureReason :partPriceFailure,
        data: priceForPart
    } = GetPartPrice(
        selectedPartNo
    )

    const reasonOptions = [
        {
            label:"shortshipment",
            value:"shortshipment",
            entryType:"credit"
        },
        {
            label:"overshipment",
            value:"overshipment",
            entryType:"debit"
        },
        {
            label:"damaged",
            value:"damaged",
            entryType:"credit"
        }
    ]

    useEffect(() => {
        if (!pageDataLoading &&  orderClaimData?.data) {
            setLoader(false)
            setClaimFormDetails({ 
                ...claimFormDetails,...orderClaimData?.data,
                ship_to_no: orderClaimData?.data?.ship_to_no.toString(),
                order_id : parseInt(orderId),
                reference : orderId.toString(),
                sales_order: state?.salesOrderNumber,
                requester_email:loggedInUserDetails?.email
            })
        }
        if (!pageDataLoading && pageDataFailure !== null) {
            setLoader(false)
            notify("ERROR", customNotification(pageDataFailure?.response?.data?.message || pageDataFailure?.message, t))
        }
    }, [orderClaimData,pageDataLoading,pageDataFailure])

    useEffect(()=>{
        if (!partPriceLoading && priceForPart) {
            let updatedParts = claimParts?.map((part)=>{
                if(part?.part_number === selectedPartNo){
                    return{
                        ...part,
                        price:priceForPart?.data !== null ? priceForPart?.data?.price : 0
                    }
                }
                else{
                    return part
                }
            })
            setClaimParts(updatedParts)
        }
        if (!partPriceLoading && partPriceFailure !== null) {
            setLoader(false)
            notify("ERROR", customNotification(partPriceFailure?.response?.data?.message || partPriceFailure?.message, t))
        }
    },[partPriceLoading,partPriceFailure,priceForPart])

    const convertPartNumberOptionsList = (response) => {
        return response?.map(({ id, part_number }) => {
            return {
                value: part_number,
                label: part_number
            }
        })
    }

    const constructOptions=()=>{
        // // Create a set of part numbers from the parts array
        // Create a set of part numbers from the parts array
        let partNumbersSet = new Set(claimFormDetails?.claimFormPartDetails?.map(part => part.part_number))

        // Filter common and different part numbers
        let commonPartNumbers = convertPartNumberOptionsList(dataObject?.associate?.parts?.filter(order => partNumbersSet.has(order.part_number)))
        let differentPartNumbers = convertPartNumberOptionsList(dataObject?.associate?.parts?.filter(order => !partNumbersSet.has(order.part_number)))
        return [
            {
                label: "Ordered Parts",
                options: commonPartNumbers
            },
            {
                label: "Other Parts",
                options: differentPartNumbers
            }
        ]
    }

    const filedValidation = useCallback((element, e) => {
        setClaimFormDetails({
            ...claimFormDetails,
            [element]: e
        })
        setErrors({
            ...errors,
            [element]: ""
        })
    },[claimFormDetails, errors])
    
    const onInputChange = useCallback(
        (e) => {
            const { name, value } = e.target
            filedValidation(name, value)
        },
        [claimFormDetails, errors]
    )

    const onDateHandler = (data,name) => {
        filedValidation(name, data)
    }

    const onPartInputChange=(e,row)=>{
        const { value,name }= e.target
        const ModifyPartId = row?.id
        let updatedParts = claimParts?.map((part)=>{
            if(part?.id === ModifyPartId){
                if(name==="quantity"){
                    let reasonType = reasonOptions.find(option=>option.value === row?.reason)?.entryType
                    if(row?.reason){    // Based to reason entryType (i.e debit or credit)
                        if(reasonType === "credit"){
                            setTotalCredit((totalCredit)- (row?.total) + (row?.price * value))
                        }
                        else{
                            setTotalCredit((totalDebit)- (row?.total) + (row?.price * value))
                        }   
                    }
                    return {
                        ...part,
                        [name]:parseInt(value),
                        total:  row?.price * value
                    }
                }
                else{
                    return {
                        ...part,
                        [name]:value
                    }
                }
            }
            else{
                return part
            }
        })
        setClaimParts(updatedParts)

    }

    const onPartSelectChange=(e,row,name)=>{
        const ModifyPartId = row?.id
        let updatedParts = claimParts?.map((part)=>{
            if(part?.id === ModifyPartId){
                if(name === "part_number"){    // we need fetch the price of the part, API call will happen
                    let partNumbers = dataObject?.associate?.parts?.filter(part => part.part_number === e?.value)
                    setSelectedPartNo(e?.value)
                    setKey(prevkey => prevkey + 1)
                    setPartErrors({
                        ...errors,
                        [`${name}_${row?.id}`]: ""
                    })
                    return {
                        ...part,
                        [name]:e?.value,
                        quantity: null,
                        price:null,
                        reason: "",
                        id: partNumbers[0]?.id
                    }
                }
                else if(name==="reason"){
                    let previousEntryType = reasonOptions.find(option=>option.value === row?.reason)?.entryType // 
                    let currentEntryType = e?.entryType
                    let totalPartPrice = row?.total ? row?.total : 0
                    if(previousEntryType){
                        if(previousEntryType !== currentEntryType){
                            if(previousEntryType === "credit"){
                                setTotalCredit(totalCredit- totalPartPrice)
                                setTotalDebit(totalDebit + totalPartPrice )
                            }
                            else{                                           //ie. previous entry type is debit
                                setTotalDebit(totalDebit - totalPartPrice )
                                setTotalCredit(totalCredit + totalPartPrice)
                            }
                        }
                    }else{                                      // if user select first time reason 
                        if(currentEntryType ==="credit"){
                            setTotalCredit(totalCredit + totalPartPrice)
                        }
                        else{
                            setTotalDebit(totalDebit + totalPartPrice)
                        }
                    }
                    return {
                        ...part,
                        [name]:e?.value
                    }
                }
                else{
                    return {
                        ...part,
                        [name]:e?.value
                    }
                }
            }
            else{
                return part
            }
        })
        setClaimParts(updatedParts)
    }

    const onClickDelete=(data)=>{
        setClaimParts(claimParts.filter(part => part.id !== data?.id))
    }
    const columns=[
        {
            Header: t("ClaimForm.pos"),
            accessor: "pos_no"
        },
        {
            Header: t("ClaimForm.partNo"),
            id:"part_number",
            accessor: (row) => (
                <div className="flex flex-col">
                    <CustomDropdown
                        placeholder={ t("ClaimForm.partNo") }
                        defaultValue={ row?.part_number || "" }
                        options={ constructOptions() || [] }
                        name= { `part_number_${row?.id}` }
                        changeHandler={ (e)=>onPartSelectChange(e,row,"part_number") }
                        isRequired={ true }
                        isMulti={ false }
                        disabled={ false }
                        labelIsRequired={ false }
                    />
                    <ErrorField name={ partErrors[`part_number_${row?.id}`] ? t("errorMessage.part_number"):"" } />
                </div>)
        },
        {
            Header: t("ClaimForm.qty"),
            canSort: true ,
            accessor: (row) => (
                <div className="flex flex-col w-1/2">
                    <InputBox
                        label={ t("ClaimForm.qty") }
                        id={ `quantity_${row?.id}` }
                        type="number"
                        name="quantity"
                        value={ row?.quantity }
                        errors={ errors }
                        defaultValue={ "" }
                        isRequired={ true }
                        maxLength="50"
                        isComponentLabelValidation={ true }
                        labelIsRequired={ false  }
                        onChangeHandler={ (e) => onPartInputChange(e,row) }
                        renderKey={ key }
                    />
                </div>)
            
        },
        {
            Header: t("ClaimForm.priceItem"),
            accessor: "price"
        },
        {
            Header: t("ClaimForm.priceTotal"),
            accessor: (row) => (
                <div className="flex flex-col">
                    <span className="">
                        { row?.quantity * row?.price }
                    </span>
                </div>)
        },
        {
            Header: t("ClaimForm.reason"),
            accessor: (row) => (
                <div className="flex flex-col">
                    <CustomDropdown
                        placeholder={ t("ClaimForm.reason") }
                        defaultValue={ row?.reason || "" }
                        id={ "reason" }
                        options={ reasonOptions }
                        name= { "reason" }
                        changeHandler={ (e)=>onPartSelectChange(e,row,"reason") }
                        isRequired={ true }
                        isMulti={ false }
                        disabled={ false }
                        labelIsRequired={ false }
                        renderKey={ key }
                    />
                </div>)

        },
        {
            Header: t("ClaimForm.action"),
            accessor: "action",
            textRight: true,
            disableSortBy: true,
            type: "delete",
            onActionDeleteClick: (row)=>onClickDelete(row)
        }
    ]
    
    const cancelHandler = (e) => {
        e.preventDefault()
        navigate("/order/orderHistory")
    }

    useEffect(()=>{
        setLoader(false)
    },[loader])

    const onClickAddPart=()=>{
        let newParts = [...claimParts,
            { 
                ...partRecord,
                pos_no:claimParts?.length+1,
                id : uuidv4()
            }
        ]
        setClaimParts(newParts)
    }

    const validate = (updatedFormData) => {
        let isValid = true
        let validateRules = validationRules
        Object.keys(updatedFormData).forEach((element) => {
            const formFieldName =
        typeof updatedFormData[element] === "string"
            ? updatedFormData[element].trim()
            : updatedFormData[element]
            if (!formFieldName && validateRules[element]?.required) {
                setErrors((prevError) => ({
                    ...prevError,
                    [element]: REQUIRED_VALUE
                }))
                isValid = false
            }
            if(element === "requester_email" ){
                if (!formFieldName && validateRules[element]?.required) {
                    setErrors((prevError) => ({
                        ...prevError,
                        [element]: REQUIRED_VALUE
                    }))
                    isValid = false
                }
                else if(!updatedFormData[element].match(isValidEmailRegx)){
                    setErrors((prevError) => ({
                        ...prevError,
                        [element]: t("errorMessage.emailIsvalid")
                    }))
                    isValid = false
                }
            }
        })
        return isValid
    }

    const validateParts=()=>{
        let isValid = true
        let validateRules = validatePartRules
        claimParts.forEach((part)=>{
            Object.keys(part).forEach((element) => {
                const formFieldName =
            typeof part[element] === "string"
                ? part[element].trim()
                : part[element]
                if (!formFieldName && validateRules[element]?.required) {
                    if(element === "part_number"){
                        setPartErrors((prevError) => ({
                            ...prevError,
                            [`part_number_${part?.id}`]: REQUIRED_VALUE
                        }))
                        isValid = false
                    }
                }
                
            })
            return isValid
        })
        return isObjectEmpty(partErrors)
    }

    const onFormSubmitHandler=async()=>{
        let isValidation = validate(claimFormDetails)
        let isPartValidation = validateParts()
        if (!isValidation && !isPartValidation) {
            return
        }
        if (isValidation && isPartValidation) {
            setLoader(true)
            try {
                const result =  await sendClaimForm({
                    ...claimFormDetails,
                    claimFormPartDetails:claimParts
                })
                if (result) {
                    notify("SUCCESS", customNotification(result?.message, t))
                    setLoader(false)
                    setClaimFormDetails(formDetails)
                    setClaimParts([])
                    setTimeout(() => {
                        navigate("/order/orderHistory")
                    }, 1000)
                }
            }
            catch(error){
                notify("ERROR", customNotification(error?.message, t))
                setLoader(false)
                
            }
        }
    }

    return (
        <div className="px-7 pt-4">
            <Loader loading={ loader } />
            <div className="headings mb-4">
                <h1 className="flex items-center text-2xl text-primary-50 font-black ">
                    <Link
                        onClick={ (e) => cancelHandler(e) }
                        className=" flex items-center"
                    >
                        <img src={ leftArrow } alt="Back Arrow" className="mr-3" />{ " " }
                        { t("ClaimForm.claimForm") }
                    </Link>
                </h1>
            </div>
            {
                (permission?._read || permission?._write) ? 
                    <ClaimForm
                        errors={ errors }
                        formData={ claimFormDetails }
                        columns={ columns }
                        claimParts={ claimParts }
                        permission={ permission }
                        totalCredit={ totalCredit }
                        totalDebit={ totalDebit }
                        onClickAddPart={ onClickAddPart }
                        onChangeHandler={ onInputChange }
                        onFormSubmitHandler={ onFormSubmitHandler }
                        onDateHandler={ onDateHandler }
                    />
                    : <h1>{ t("ClaimForm.permissionMessage") }</h1>
            }
            <ToastNotification />
        </div>
    )
}

export default OrderClaim
